export const professional = [
  {
    number: 'HN100',
    hasModel: false
  },
  {
    number: 'HN101',
    hasModel: false
  },
  {
    number: 'HN102',
    hasModel: false
  },
  {
    number: 'HN103',
    hasModel: false
  },
  {
    number: 'HN104',
    hasModel: false
  },
  {
    number: 'HN105',
    hasModel: false
  },
  {
    number: 'HN106',
    hasModel: false
  },
  {
    number: 'HN107',
    hasModel: false
  },
  {
    number: 'HN108',
    hasModel: false
  },
  {
    number: 'HN109',
    hasModel: false
  },
  {
    number: 'HN110',
    hasModel: false
  },
  {
    number: 'HN111',
    hasModel: false
  },
  {
    number: 'HN112',
    hasModel: false
  },
  {
    number: 'HN113',
    hasModel: false
  },
  {
    number: 'HN114',
    hasModel: false
  },
  {
    number: 'HN115',
    hasModel: false
  },
  {
    number: 'HN116',
    hasModel: false
  },
  {
    number: 'HN117',
    hasModel: false
  },
  {
    number: 'HN118',
    hasModel: false
  },
  {
    number: 'HN119',
    hasModel: false
  },
  {
    number: 'HN120',
    hasModel: false
  },
  {
    number: 'HN121',
    hasModel: false
  },
  {
    number: 'HN122',
    hasModel: false
  },
  {
    number: 'HN123',
    hasModel: false
  },
  {
    number: 'HN124',
    hasModel: false
  },
  {
    number: 'HN125',
    hasModel: false
  },
  {
    number: 'HN126',
    hasModel: false
  },

]